import styled from "@emotion/styled";
const JOiningLinks = styled.img`
  width: 100%;
  height:auto;
  max-width: ${(props) => (props.mw ? props.mw : "140PX")};
`;
const Wrap = styled.div`
display:flex;
align-items:center;
justify-content:center;
gap:30px;
`;
export {JOiningLinks,Wrap};
